import { createEventEmitter } from "@/events";
import { DIALOG_ID, type DialogType, EVENT_SUFFIXES } from "@/types";
import type {
    RedeemTransactionProps,
    DepositTransactionProps,
    LockTransactionProps,
    MintTransactionProps,
    LockFormDialogProps,
    ChangeDurationFormDialogProps,
    CancelExitTransactionProps,
    ClaimTransactionProps,
    WithdrawUnwoundTransactionProps,
} from "@/components";

export const DIALOG_EVENTS = {
    OPEN: `${DIALOG_ID}:${EVENT_SUFFIXES.OPEN}`,
    CLOSE: `${DIALOG_ID}:${EVENT_SUFFIXES.CLOSE}`,
} as const;

export interface DialogOpenPayload {
    dialogType: DialogType;
    props: DialogOpenPayloadProps;
}

export type DialogOpenPayloadProps =
    | LockFormDialogProps
    | MintTransactionProps
    | LockTransactionProps
    | DepositTransactionProps
    | RedeemTransactionProps
    | ChangeDurationFormDialogProps
    | ClaimTransactionProps
    | WithdrawUnwoundTransactionProps
    | CancelExitTransactionProps;

export type DialogClosePayload = Record<never, never>;

export interface DialogEventPayloads extends Record<string, unknown> {
    [DIALOG_EVENTS.OPEN]: DialogOpenPayload;
    [DIALOG_EVENTS.CLOSE]: DialogClosePayload;
}

export const dialogEventEmitter = createEventEmitter<DialogEventPayloads>();
